import axiosInstance from "./AxiosInstance";

export const getProgressTracker = async () => {
  try {
    const response = await axiosInstance.get("api/progress-tracking/dashboard");
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching progress:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const googleLogout = async () => {
  try {
    const response = await axiosInstance.delete("api/google-fit/logout");
    return response.data;
  } catch (error) {
    console.error(
      "Error logging out:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};
